import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/GlobalSearchResultsSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.globalSearchResults || initialState;

export const selectLoading = createSelector([selectDomain], (state) => state.isGlobalSearchLoading);
export const peopleData = createSelector([selectDomain], (state) => state.peopleSection);
export const documentData = createSelector([selectDomain], (state) => state.documentSection);
export const companiesData = createSelector([selectDomain], (state) => state.companiesSection);
export const buyerGroupsData = createSelector([selectDomain], (state) => state.buyerGroupsSection);
export const articlesData = createSelector([selectDomain], (state) => state.articlesSection);
export const industriesData = createSelector([selectDomain], (state) => state.industriesSection);
export const selectSearchText = createSelector([selectDomain], (state) => state.searchText);

export const selectCompaniesFollowedSearchResults = createSelector(
  [selectDomain],
  (state) => state.companiesSection.followedCompanies,
);

export const selectPeopleFollowedSearchResults = createSelector(
  [selectDomain],
  (state) => state.peopleSection.followedPersons,
);

export const selectCompanyResultsEnded = createSelector(
  [selectDomain],
  (state) => state.isCompanySearchEnded,
);

export const selectErrorText = createSelector(
  [selectDomain],
  (state) => state.errorText,
);
export const selectPersonLoaded = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoaded,
);
export const selectPersonLoading = createSelector(
  [selectDomain],
  (state) => state.isPersonExtendedLoading,
);

export const selectCompanyLoaded = createSelector(
  [selectDomain],
  (state) => state.isCompanyExtendedLoaded,
);
export const selectCompanyLoading = createSelector(
  [selectDomain],
  (state) => state.isCompanyExtendedLoading,
);

export const selectSearchLoaded = createSelector(
  [selectDomain],
  (state) => state.isGlobalSearchLoaded,
);

export const selectIsPagination = createSelector(
  [selectDomain],
  (state) => state.isPagination,
);
export const selectBuyerGroupsLoaded = createSelector(
  [selectDomain],
  (state) => state.isBuyerGroupExtendedLoaded,
);
export const selectBuyerGroupsLoading = createSelector(
  [selectDomain],
  (state) => state.isBuyerGroupExtendedLoading,
);
export const selectGlobalSearchScreenName = createSelector(
  [selectDomain],
  (state) => state.screenName,
);
